import { useNavigate } from "react-router";
import { useAppSelector } from "@/common/hooks/useRedux";
import { RecordingState } from "@/common/utils/types";
import { TOUCH_HIT_AREA } from "@/common/utils/touchTarget";
import { COPY } from "./copy";

/**
 * Opens the visit a merged-away visit was merged into. While recording (or paused) it opens a new tab:
 * the recording widget finishes a recording when this tab navigates, and that recording must carry on.
 */
export function OpenKeptVisitButton({
    keptVisitId,
    keptTime = "",
    className,
}: {
    keptVisitId: string;
    /** The kept visit's time for the label, when the caller knows it. */
    keptTime?: string;
    className?: string;
}) {
    const navigate = useNavigate();
    const recording = useAppSelector((s) => {
        const state = s.globalState?.globalRecordingState;
        return state === RecordingState.recording || state === RecordingState.paused;
    });
    const path = `/appointments/${keptVisitId}`;
    return (
        <button
            type="button"
            className={`${TOUCH_HIT_AREA} ${className ?? ""}`}
            onClick={() => (recording ? window.open(path, "_blank", "noopener") : navigate(path))}
        >
            {COPY.recycleOpenKept(keptTime)}
        </button>
    );
}
